import React from 'react';
import { Link } from 'react-router-dom';
import './WorkWithMe.css';
import Navbar from '../pages/Navbar';
import Footer from '../pages/Footer';
import SEO, { professionalServiceSchema } from '../components/SEO';

const LETS_CONNECT_IMAGE = 'https://firebasestorage.googleapis.com/v0/b/pp-studio-website.firebasestorage.app/o/library%2Fjourney-ch4%2FLetsConnect.jpeg?alt=media&token=7f066927-9ba1-4174-ac94-b7219af5eef7';

function WorkWithMe() {
  return (
    <>
      <SEO
        title="Work With Pooja Biswal — Contract Review & Specialist Services"
        description="Hire Pooja Biswal for contract review, drafting and negotiation. LLM (Distinction) Queen Mary London — helping freelancers and SMEs protect their interests."
        keywords="hire contract specialist UK, contract review service London, freelance legal consultant, contract drafting service, NDA review UK, commercial contracts consultant, work with contract specialist"
        canonical="/work-with-me"
        schema={professionalServiceSchema()}
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Work With Me", path: "/work-with-me" }]}
      />
      <Navbar />

      <section className="wwm-page">
        <div className="wwm-frame">
          <div className="wwm-content">
            <span className="wwm-kicker">A quick note on availability</span>
            <h1 className="wwm-heading">Not taking on new freelance work right now.</h1>
            <p className="wwm-body">
              I'm currently in full-time employment, so this platform isn't set up for
              freelance work, paid engagements, or client projects at the moment.
            </p>
            <p className="wwm-body">
              What I'm happy to share: insights, resources, guidance, and free mentoring.
            </p>
            <p className="wwm-body">
              And beyond that, I'm always glad to hear from people — whether it's about a
              future opportunity, a quick question, or simply a hello. Reach out, and
              I'll get back to you.
            </p>
            <div className="wwm-actions">
              <Link to="/#contact" className="wwm-cta">
                Let's Connect
              </Link>
              <Link to="/journey" className="wwm-cta-secondary">My Journey</Link>
              <Link to="/skills" className="wwm-cta-secondary">My Skills</Link>
            </div>
          </div>

          <div className="wwm-photo">
            <img src={LETS_CONNECT_IMAGE} alt="Pooja Biswal" loading="lazy" />
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default WorkWithMe;
